export const COMPANY_INFO_MAX_LENGTH = 600;

export function getCompanyNameError(name) {
  if (!name?.trim()) {
    return 'Bitte einen Firmennamen eingeben.';
  }
  return '';
}

export function getCompanyInfoError(info) {
  if (info == null || info === '') return '';

  const length = String(info).length;
  if (length <= COMPANY_INFO_MAX_LENGTH) return '';

  return `Beschreibung ist ${length} Zeichen lang, maximal ${COMPANY_INFO_MAX_LENGTH} erlaubt.`;
}

export function getCompanyCreateEmailError(email) {
  if (!email?.trim()) {
    return 'Bitte eine E-Mail-Adresse eingeben.';
  }
  return '';
}
